import React from 'react';
import './Footer.css';
import PartnerIcon1 from './imgs/p1.png'
import PartnerIcon2 from './imgs/p2.png'
import PartnerIcon3 from './imgs/p3.png'
import PartnerIcon4 from './imgs/p4.png'
import PartnerIcon5 from './imgs/p5.svg'
import PartnerIcon6 from './imgs/p6.png'
import PartnerIcon7 from './imgs/p7.png'
import PartnerIcon8 from './imgs/p8.png'
import PartnerIcon9 from './imgs/p9.png'
import PartnerIcon10 from './imgs/p10.png'

const Footer = () => {
    return (
        <div className='footer-main'>
            <div className='container'>
                <div className='footer-main-wrapper'>
                    <div className='partners-main'>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon1} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon2} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon3} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon4} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon5} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon6} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon7} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon8} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon9} alt='Partners'></img>
                        </div>
                        <div className='partners-main-item'>
                            <img src={PartnerIcon10} alt='Partners'></img>
                        </div>
                    </div>

                    <div className='copyright-text'>
                        <p>All Rights Reserved © Digital Wallonia 2024.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
